import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"
import LabTestDescription from "@widgets/LabTestDescription/LabTestDescription.skeleton"
import PanelDetailsCaraousal from "@widgets/PanelDetailsCarousel/PanelDetailsCarousel.skeleton"
import { StillAndMovingImagesDefault } from "@widgets/StillAndMovingImages/StillAndMovingImages.skeleton"
import { FootNotesLabs } from "@widgets/Footnotes/Footnotes.skeleton"
import ListOfFeatures from "@widgets/ListOfFeatures/ListOfFeatures.skeleton"
import WalkInDetails from "@widgets/WalkInDetails/WalkInDetails.skeleton"
import { HorizontalPackageListing } from "@widgets/HorizontalPackageListing/HorizontalPackageListing.skeleton"
import { ListOfTestCarouselLabDetails } from "@widgets/ListOfTestCarousel/ListOfTestCarousel.skeleton"
const VerticalDivider = [{ span: 2 }]

function LabsDetailsSkeleton() {
    return (
        <div className="page-container">
            <div className="container-fluid flex">
                <div className="flex-column">
                    <div className="widget-container marginBoth-8 ">
                        <Skeleton config={LabTestDescription} isComponent></Skeleton>
                    </div>
                    <div className="widget-container marginBoth-8 ">
                        <Skeleton config={WalkInDetails} isComponent></Skeleton>
                    </div>
                    <div className="widget-container marginBoth-8 ">
                        <Skeleton config={StillAndMovingImagesDefault} isComponent></Skeleton>
                    </div>
                    <div className="widget-container marginBoth-8 ">
                        <Skeleton config={FootNotesLabs} isComponent></Skeleton>
                    </div>
                </div>
                <div className="flex-column">
                    <Skeleton config={VerticalDivider} isComponent></Skeleton>
                </div>
                <div className="flex-column">
                    <div className="widget-container marginBoth-8 col-8">
                        <Skeleton config={HorizontalPackageListing} isComponent></Skeleton>
                    </div>
                    <div className="widget-container marginBoth-8 col-8">
                        <Skeleton config={ListOfTestCarouselLabDetails} isComponent></Skeleton>
                    </div>
                    <div className="widget-container marginBoth-8 col-8">
                        <Skeleton config={PanelDetailsCaraousal} isComponent></Skeleton>
                    </div>
                    <div className="widget-container marginBoth-8 col-8">
                        <Skeleton config={ListOfFeatures} isComponent></Skeleton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LabsDetailsSkeleton
